import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import {
  AlertComponent,
  CardSelectComponent,
  ModalComponent,
} from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Modal Demo vs Plan de pago al crear contrato (Figma PIF-268).
 */
@Component({
  selector: 'app-contrato-tipo-modal',
  standalone: true,
  imports: [ModalComponent, CardSelectComponent, AlertComponent, TranslatePipe],
  template: `
    <tec-modal
      [isVisible]="isVisible()"
      [title]="'CREAR_CONTRATO.MODAL_TIPO_TITLE' | translate"
      [buttonPrimaryLabel]="'COMMON.CONTINUE' | translate"
      [buttonSecondaryLabel]="'COMMON.CANCEL' | translate"
      (closeEvent)="onClose($event)"
    >
      <ng-container body>
        <div class="grid grid-i2">
          <tec-card-select
            [title]="'CREAR_CONTRATO.MODAL_TIPO_DEMO_TITLE' | translate"
            [description]="'CREAR_CONTRATO.MODAL_TIPO_DEMO_DESC' | translate"
            [tagImg]="{ icon: 'icon-package', status: 'simple' }"
            [selected]="seleccion() === 'demo'"
            (selectedChange)="onSelect('demo', $event)"
          ></tec-card-select>
          <tec-card-select
            [title]="'CREAR_CONTRATO.MODAL_TIPO_PLAN_TITLE' | translate"
            [description]="'CREAR_CONTRATO.MODAL_TIPO_PLAN_DESC' | translate"
            [tagImg]="{ icon: 'icon-package', status: 'success' }"
            [selected]="seleccion() === 'plan'"
            (selectedChange)="onSelect('plan', $event)"
          ></tec-card-select>
        </div>
        @if (alertaVisible()) {
          <tec-alert
            [msg]="'CREAR_CONTRATO.MODAL_TIPO_ALERT' | translate"
            [status]="'warning'"
            (closeAlert)="alertaVisible.set(false)"
          ></tec-alert>
        }
      </ng-container>
    </tec-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContratoTipoModalComponent {
  readonly isVisible = input(false);
  readonly confirmado = output<'demo' | 'plan'>();
  readonly cancelado = output<void>();

  readonly seleccion = signal<'demo' | 'plan' | null>(null);
  readonly alertaVisible = signal(false);

  onSelect(tipo: 'demo' | 'plan', selected: boolean): void {
    if (!selected) {
      if (this.seleccion() === tipo) {
        this.seleccion.set(null);
      }
      return;
    }
    this.seleccion.set(tipo);
    this.alertaVisible.set(false);
  }

  onClose(event: 'buttonPrimary' | 'buttonSecondary' | null): void {
    if (event === 'buttonPrimary') {
      const sel = this.seleccion();
      if (sel == null) {
        this.alertaVisible.set(true);
        return;
      }
      this.confirmado.emit(sel);
      return;
    }
    this.cancelado.emit();
  }
}
